import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import {
  AddCheckedItemsToAssortment,
  CentralAssortmentMemberView,
} from '@retail/my-assortment/containers';
import { AssortmentItemMinimal } from '@retail/my-assortment/types';
import { Paper } from '@mui/material';
import { useState } from 'react';
import { useDisclosure } from '@shared/hooks';
import { AddItemToAssortment } from '@retail/products/containers';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';

export function CentralAssortmentMemberViewPage() {
  const { assortmentId } = useSelectedOrgUnit();

  const { isOpen: isAddCheckedItemsOpen, onToggle: toggleAddCheckedItemsModal } = useDisclosure();

  const [itemsChecked, setItemsChecked] = useState<AssortmentItemMinimal[]>([]);
  const [itemToAdd, setItemToAdd] = useState<AssortmentItemMinimal | undefined>(undefined);

  const handleOnClose = () => {
    setItemsChecked([]);
    toggleAddCheckedItemsModal();
  };

  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <SuspenseWithSentryErrorBoundary>
          <CentralAssortmentMemberView
            includeTitle
            itemsChecked={itemsChecked}
            toggleAddCheckedItemsModal={toggleAddCheckedItemsModal}
            setItemsChecked={setItemsChecked}
            setItemToAdd={setItemToAdd}
          />
        </SuspenseWithSentryErrorBoundary>

        {!!itemToAdd && (
          <AddItemToAssortment
            open
            mgItemNumber={itemToAdd.mgItemNumber}
            supplierId={itemToAdd.supplier.id}
            onClose={() => setItemToAdd(undefined)}
          />
        )}
        {isAddCheckedItemsOpen && (
          <AddCheckedItemsToAssortment
            open
            assortmentId={assortmentId}
            selectedItems={itemsChecked}
            onClose={handleOnClose}
          />
        )}
      </Paper>
    </PageLayout>
  );
}
